/*==============================================================================
ACHG Collection Framework v2.0 Premium UI

File:
assets/achg-collection.js

Purpose:
Collection Initialization Module

==============================================================================*/

(function () {

    'use strict';


    function initACHGCollection() {


        document.documentElement.classList.add(
            'achg-collection-ready'
        );


        initCards();


    }



    function initCards() {


        const cards = document.querySelectorAll(
            '.achg-card'
        );


        if (!cards.length) return;


        cards.forEach(function (card) {


            if (card.dataset.achgReady) return;


            card.dataset.achgReady = 'true';


        });


    }



    document.addEventListener(
        'DOMContentLoaded',
        initACHGCollection
    );


    document.addEventListener(
        'shopify:section:load',
        initACHGCollection
    );


})();